// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu-module--menu--7wDaf","open":"menu-module--open--auqf4"};